export default "__VITE_ASSET__en_R6BFn__"